/* Cacheable post-init owner for PDP shadow, size-guide link and modal scroll-state fixes. */
(function(){
  'use strict';
/* One modal-state owner for every custom PDP sheet. It delegates to the theme's
   lock-counted iOS utility, keeps a safe fallback for an unusually early click,
   and exposes one state event for the mobile sticky bar. */
(function(){
  if(window.SJW_PDP_MODAL)return;
  var open={},fallbackCount=0,fallback=null,settleCancel=null,order=0;
  function core(){return window.themeCore&&window.themeCore.utils&&window.themeCore.utils.bodyScrollLock;}
  function state(){
    var any=Object.keys(open).length>0;
    document.documentElement.classList.toggle('sjw-pdp-modal-open',any);
    try{document.dispatchEvent(new CustomEvent('sjw:pdp-modal-state',{detail:{open:any}}));}catch(e){}
  }
  function stopSettle(){if(settleCancel){settleCancel();settleCancel=null;}}
  function settleScroll(s){
    stopSettle();
    var cancelled=false,start=performance.now(),anchor=s.anchor,anchorTop=s.anchorTop;
    function cleanup(){
      if(cancelled)return;cancelled=true;
      window.removeEventListener('touchstart',cancel,true);window.removeEventListener('pointerdown',cancel,true);
      window.removeEventListener('wheel',cancel,true);window.removeEventListener('keydown',cancel,true);
      if(settleCancel===cleanup)settleCancel=null;
    }
    function cancel(){cleanup();}
    window.addEventListener('touchstart',cancel,{capture:true,passive:true,once:true});
    window.addEventListener('pointerdown',cancel,{capture:true,passive:true,once:true});
    window.addEventListener('wheel',cancel,{capture:true,passive:true,once:true});
    window.addEventListener('keydown',cancel,{capture:true,once:true});
    function tick(now){
      if(cancelled)return;
      var targetY=s.y;
      if(anchor&&anchor.isConnected&&anchorTop!=null)targetY=window.scrollY+(anchor.getBoundingClientRect().top-anchorTop);
      if(Math.abs(window.scrollY-s.y)>48&&Math.abs(targetY-window.scrollY)>48){cleanup();return;}
      if(Math.abs(targetY-window.scrollY)>.25)window.scrollTo(s.x,targetY);
      if(now-start<600)requestAnimationFrame(tick);else cleanup();
    }
    settleCancel=cleanup;requestAnimationFrame(tick);
  }
  function fallbackLock(anchor){
    stopSettle();
    fallbackCount++;
    if(fallbackCount>1)return;
    var b=document.body,h=document.documentElement;
    fallback={x:window.scrollX||0,y:window.scrollY||0,
      anchor:anchor&&anchor.isConnected?anchor:null,anchorTop:anchor&&anchor.isConnected?anchor.getBoundingClientRect().top:null,
      bp:b.style.position,bt:b.style.top,bl:b.style.left,bw:b.style.width,bh:b.style.height,bo:b.style.overflow,
      hh:h.style.height,ho:h.style.overflow};
    h.style.height='100%';h.style.overflow='hidden';
    b.style.position='fixed';b.style.top=(-fallback.y)+'px';b.style.left=(-fallback.x)+'px';
    b.style.width='100%';b.style.height='auto';b.style.overflow='hidden';
  }
  function fallbackUnlock(){
    fallbackCount=Math.max(0,fallbackCount-1);
    if(fallbackCount||!fallback)return;
    var b=document.body,h=document.documentElement,s=fallback;fallback=null;
    h.style.height=s.hh;h.style.overflow=s.ho;
    b.style.position=s.bp;b.style.top=s.bt;b.style.left=s.bl;b.style.width=s.bw;b.style.height=s.bh;b.style.overflow=s.bo;
    window.scrollTo(s.x,s.y);
    settleScroll(s);
  }
  function dialogFor(surface,dialog){
    if(dialog)return dialog;
    if(surface&&surface.closest){
      return surface.closest('[role="dialog"],[aria-modal="true"],.sjw-cg,.sjw-sum-modal,#sjw-hint-modal')||surface;
    }
    return surface||document.body;
  }
  function topItem(){
    var best=null;
    Object.keys(open).forEach(function(key){if(!best||open[key].order>best.order)best=open[key];});
    return best;
  }
  function visible(el){
    if(!el||el.disabled||el.getAttribute('aria-hidden')==='true')return false;
    var st=getComputedStyle(el);
    return st.display!=='none'&&st.visibility!=='hidden'&&el.getClientRects().length>0;
  }
  function trapTab(e){
    if(e.key!=='Tab')return;
    var item=topItem(),dialog=item&&item.dialog;
    if(!dialog)return;
    var nodes=[].slice.call(dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(visible);
    if(!nodes.length){
      if(!dialog.hasAttribute('tabindex'))dialog.setAttribute('tabindex','-1');
      e.preventDefault();try{dialog.focus({preventScroll:true});}catch(_){dialog.focus();}return;
    }
    var first=nodes[0],last=nodes[nodes.length-1],active=document.activeElement;
    if(e.shiftKey&&(active===first||!dialog.contains(active))){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&(active===last||!dialog.contains(active))){e.preventDefault();first.focus();}
  }
  function lock(key,surface,opener,dialog){
    if(!key||open[key])return;
    surface=surface||document.body;
    var api=core();
    open[key]={surface:surface,dialog:dialogFor(surface,dialog),opener:opener||document.activeElement,api:api,order:++order};
    /* Keep one physical scroll-position owner. The theme utility already pins
       iOS documents and restores their saved position; stacking our fixed-body
       fallback on top makes close restore the PDP twice and visibly jump. */
    if(api)api.disableBodyScroll(surface,{
      reserveScrollBarGap:true,
      allowTouchMove:function(el){
        return !!(el&&el.closest&&el.closest('#sjw-size-guide input[type="range"]'));
      }
    });
    else fallbackLock(open[key].opener);
    state();
  }
  function unlock(key){
    var item=open[key];if(!item)return;
    delete open[key];
    /* Return focus while the document is still pinned. Some mobile browsers
       ignore preventScroll after a fixed body is released and nudge the PDP
       toward the trigger; restoring the saved scroll position last avoids it. */
    if(item.opener&&item.opener.focus){try{item.opener.focus({preventScroll:true});}catch(e){try{item.opener.focus();}catch(_){}}}
    if(item.api)item.api.enableBodyScroll(item.surface);
    else fallbackUnlock();
    state();
  }
  document.addEventListener('keydown',trapTab,true);
  window.SJW_PDP_MODAL={lock:lock,unlock:unlock,isOpen:function(){return Object.keys(open).length>0;}};
})();
/* The customizer's per-template ID rules (#sjwpp-template-... !important) outrank any class override,
   so the halo shadows are rewritten in the CSSOM directly. */
(function(){
  function fix(){
    try{
      [].slice.call(document.styleSheets).forEach(function(ss){
        var rules;try{rules=ss.cssRules;}catch(e){return;}
        if(!rules)return;
        function scan(rr){
          if(rr.selectorText&&rr.selectorText.indexOf('sjwpp-')>-1&&rr.style&&/(14px 26px|6px 16px)/.test(rr.style.boxShadow||'')){
            rr.style.setProperty('box-shadow','0 4px 10px rgba(44,74,65,.28)','important');
          }
          if(rr.cssRules){for(var j=0;j<rr.cssRules.length;j++)scan(rr.cssRules[j]);}
        }
        for(var i=0;i<rules.length;i++)scan(rules[i]);
      });
    }catch(e){}
  }
  if(document.readyState!=='loading')fix();else document.addEventListener('DOMContentLoaded',fix);
  window.addEventListener('load',fix);
})();
/* Ring size guide modal: link to the full Ring Size & Fit page (injected — the 34KB snippet stays untouched) */
(function(){
  function add(){
    var pane=document.querySelector('#sjw-size-guide [data-sgpane="finder"]');
    if(!pane||document.getElementById('sjw-sg-fitlink'))return;
    var tip=pane.querySelector('.sjw-sg-tip');
    var p=document.createElement('p');
    p.id='sjw-sg-fitlink';
    p.style.cssText='margin:10px 0 0;font-size:calc(11.5px * var(--sjw-scale,1));';
    p.innerHTML='<a href="/pages/ring-size-fit" target="_blank" rel="noopener" style="color:#8A6F42;font-weight:500;letter-spacing:.04em;text-decoration:none;border-bottom:1px solid #E4D4B6;padding-bottom:1px;">Read our complete Ring Size &amp; Fit guide &rarr;</a>';
    if(tip&&tip.parentNode)tip.parentNode.insertBefore(p,tip.nextSibling);
    else pane.appendChild(p);
  }
  if(document.readyState!=='loading')add();else document.addEventListener('DOMContentLoaded',add);
  window.addEventListener('load',add);
})();
(function(){
  function init(){
    var ovl=document.querySelector('[data-sjw-size-guide-overlay]');
    if(!ovl||ovl.__sjwSgLock)return; ovl.__sjwSgLock=1;
    function vis(){return getComputedStyle(ovl).display!=='none';}
    function sync(){var api=window.SJW_PDP_MODAL;if(!api)return;vis()?api.lock('ring-size',ovl.firstElementChild,null,ovl.firstElementChild):api.unlock('ring-size');}
    new MutationObserver(sync).observe(ovl,{attributes:true,attributeFilter:['style','class','aria-hidden']});
    if(vis())sync();
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  window.addEventListener('load',init);
})();
})();
